import UseCase from "@domain/UseCase";
import DatabaseRemoveJobRepository from "@domain/repositories/DatabaseRemoveJobRepository";
import { RemoveJob } from "@domain/models/RemoveJob";

type Input = RemoveJob["id"];

type Output = void;

export class WatchPendingRemoveJob implements UseCase<Input, Output> {
  constructor(private readonly removeJobRepository: DatabaseRemoveJobRepository) {}

  execute(jobId: RemoveJob["id"]) {
    return this.removeJobRepository.watchPendingRemoves(jobId);
  }
}
